import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const Lightbox = ({ src, alt, onClose }) => (
  <AnimatePresence>
    {src && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
        data-testid="lightbox-overlay"
        className="fixed inset-0 z-[200] bg-[#0B2530]/90 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
        onClick={onClose}
      >
        <button
          data-testid="lightbox-close"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-5 right-5 z-10 p-3 rounded-full bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors duration-300"
        >
          <X size={22} />
        </button>
        <motion.img
          initial={{ scale: 0.92, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
          src={src}
          alt={alt || "Poster"}
          data-testid="lightbox-image"
          className="max-w-full max-h-full object-contain rounded-xl shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        />
      </motion.div>
    )}
  </AnimatePresence>
);
